import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/biscuits/gulcose biscuit.png";
import BiscuitImg from "../../../assets/products/biscuits/Glucose-Biscuit.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 8,
  },
  {
    grams: 10,
  },
  {
    grams: 30,
  },
  {
    grams: 45,
  },
  {
    grams: 50,
  },
  {
    grams: 55,
  },
  {
    grams: 60,
  },
];

export default function GlucoseProduct() {
  return (
    <>
      <Helmet>
        <title>Glucose Biscuits – BearBitz | Premium Biscuits & Cookies</title>
        <meta
          name="description"
          content="Explore BearBitz Glucose Biscuits—crispy, energy-packed, and perfect for all ages. View pack sizes, cartons, and specs for global food manufacturing."
        />
        <meta
          name="keywords"
          content="Glucose Biscuits, BearBitz Glucose Biscuits"
        />
        <link rel="canonical" href="https://www.bearbitz.in/biscuits/glucose" />
        <meta property="og:title" content="Glucose Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Crispy and energy-rich glucose biscuits. Global-ready specs and packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="GLUCOSE BISCUITS"
        productImage={BisImg}
        description="Power-Packed Bites of Energy. Crispy, mildly sweet, and full of goodness perfect for all ages, anytime. Trusted in tea breaks and snack times across the globe."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#004A67"
        sectionBgColor="#A7E6FF"
        productBgcolor="#3DC9FF"
        tableheadBgcolor="#3DC9FF"
        tableBgcolor="#ddf5ff"
        footerBgcolor="#3DC9FF"
      />
    </>
  );
}
